import CustomContainer from "../../components/common/CustomContainer"
import styles from "../../assets/styles/appointments.module.css"
import { Tab, Tabs } from "@mui/material"
import { CustomTabPanel, a11yProps } from "../../components/common/CustomTabPanel"
import { useState } from "react"
import UpComing from "../../components/myAppointments/UpComing"
import Completed from "../../components/myAppointments/Completed"
import Cancelled from "../../components/myAppointments/Cancelled"
import { useNavigate } from "react-router-dom"
import Pending from "../../components/myAppointments/Pending"

const MyAppointment = () => {
    const [value, setValue] = useState(0);
    const navigate = useNavigate();
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <CustomContainer>
            <div className={'AllPageMain'}>
                <div className={'HeadAndButton'}>
                    <h2>Doctor Appointment</h2>
                </div>
                <div className={styles.appointmentsMain}>
                    <Tabs value={value} onChange={handleChange} className="custumTabs">
                        <Tab label="Pending request" {...a11yProps(0)} />
                        <Tab label="Upcoming" {...a11yProps(1)} />
                        <Tab label="Completed" {...a11yProps(2)} />
                        <Tab label="Cancelled" {...a11yProps(2)} />
                    </Tabs>
                    <CustomTabPanel value={value} index={0}>
                        <Pending />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <UpComing />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                        <Completed />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={3}>
                        <Cancelled />
                    </CustomTabPanel>
                </div>
            </div>
        </CustomContainer>
    )
}

export default MyAppointment